import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./WalletInnerPage.css";
import CommonBreadcrumb from "./../../../../common_components/breadcrumb/CommonBreadcrumb";
import WhiteButton from "./../../../../common_components/common_button/WhiteButton";
import MoneyLottie from "./../../../../animation/money_lottie/MoneyLottie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSliders } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetUserTransaction } from "../../../../../features/admin/auth/Slice";

const WalletInnerPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userTransaction = useSelector(
    (state) => state?.auth?.login?.getUserTransactionData,
  );

  useEffect(() => {
    dispatch(GetUserTransaction());
  }, [dispatch]);

  const breadcrumbItems = [
    { label: "profile", link: "/profile" },
    { label: "Wallet & Earnings" },
  ];

  return (
    <section className="wallet-inner-page">
      <CommonBreadcrumb items={breadcrumbItems} />

      <Container className="wallet-container">
        <Row className="justify-content-center">
          <Col lg={7}>
            {/* Wallet Card */}
            <div className="wallet-card">
              <div className="wallet-card-left">
                <p className="wallet-label">Current Balance</p>
                <h2 className="wallet-amount">
                  ₹ {userTransaction?.total_unpaid_amount}
                </h2>
                <p className="wallet-payout">
                  *Payout On: 1st Day Of Every Month
                </p>
              </div>

              <div className="wallet-card-right">
                <img src="images/profile/wallet.png" alt="wallet" />
              </div>
            </div>

            {/* Add Bank Section  not to show as per prajwal sir*/}
            {/* <div className="add-bank-section">
              <p className="add-bank-text">
                Please <span>Add Your Bank Account </span>Details To Continue With Payouts
              </p>
              <MoneyLottie/>
              <button className="add-bank-btn">Add Bank & Complete KYC</button>
              <div className="add-bank-btn">
                <WhiteButton
                  title={"Add Bank & Complete KYC"}
                  bg="#000"
                  color="#f35f37"
                  hoverColor="#f35f37"
                  hoverBg={"#000"}
                  onClick={()=>navigate("/identityVarification")}
                />
              </div>
            </div> */}

            {/* Payout History Section */}
            {/* <div className="payout-section">
              <div className="payout-header">
                <h6>Recent Pay Out History</h6>
                <span className="filter-text">
                  Filter:
                  <FontAwesomeIcon className="filter-icon" icon={faSliders} />
                </span>
              </div>

              <div className="empty-state">
                <img
                  src="images/profile/wallet/notransaction.png"
                  alt="no data"
                />
                <p className="empty-title">No recent transactions</p>
                <p className="empty-subtitle">
                  Payouts will be visible here once you place a request.
                </p>
              </div>
            </div> */}
            <div className="payout-section">
              <div className="payout-header">
                <h6>Recent Pay Out History</h6>
              </div>

              {userTransaction?.history &&
              userTransaction?.history?.length > 0 ? (
                <div className="table-responsive">
                  <table className="table payout-table">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userTransaction?.history?.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>₹ {item.amount}</td>
                          <td>
                            <span
                              className={`status-badge ${
                                item.status === "paid" ? "success" : "pending"
                              }`}
                            >
                              {item.status}
                            </span>
                          </td>
                          <td>
                            {new Date(item.created_at).toLocaleDateString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="empty-state">
                  <img
                    src="images/profile/wallet/notransaction.png"
                    alt="no data"
                  />
                  <p className="empty-title">No recent transactions</p>
                  <p className="empty-subtitle">
                    Payouts will be visible here once you place a request.
                  </p>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WalletInnerPage;
